<template>
  <div>
    <div v-if="!edit" @dblclick="openEdit">
      <feather-icon
        style="float: right"
        icon="ChevronDownIcon"
        svgClasses="h-5 w-5 mr-1 hover:text-primary cursor-pointer z-100"
      />
      {{ value }}
    </div>
    <div v-else>
      <!-- <v-select
        v-model="select"
        :options="options"
        class="select-edit-column"
        :reduce="(item) => item.value"
        label="label"
        :clearable="false"
        @input="submit"
        @keyup.esc="closeEdit"
      /> -->
      <select
        v-model="select"
        @change="submit"
        @keyup.esc="closeEdit"
        class="select-edit-column w-full"
      >
        <option v-for="(option, i) in options" :key="i" :value="option.value">
          {{ option.label }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import vSelect from 'vue-select'
export default {
  components: {
    ActionIcon,
    'v-select': vSelect,
  },
  props: {
    keys: {
      type: Object,
      required: true,
      default: {
        value: '',
        label: '',
      },
    },
    value: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      edit: false,
      select: null,
      options: [],
    }
  },
  methods: {
    openEdit() {
      this.options = this.items.map((item) => ({
        value: item[this.keys.value],
        label: item[this.keys.label],
      }))
      if (this.options.length > 0) {
        this.select = this.options[0].value
        if (this.value !== null) {
          let item = this.options.find((item) => item.value == this.value)
          this.select = item.value
        }
      }

      this.edit = true
    },
    closeEdit() {
      this.edit = false
    },
    submit() {
      this.closeEdit()
      this.$emit('update', this.select)
    },
  },
}
</script>

<style>
.select-edit-column {
  border-radius: 5px;
  font-size: 1rem;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.7rem !important;
}

.select-edit-column > .vs__dropdown-menu {
  position: relative;
  height: 50px;
  z-index: 100;
}
</style>